import { MediaWithAlbum } from '@bpm-web-app/stream-api-sdk';
import { Album as DownloadAlbum } from '@bpm-web-app/download-api-sdk';
import { useTrending } from '@bpm-web-app/swr-hooks';
import { useHubSwitch, DEFAULT_PERIOD, DEFAULT_BROWSE_TRENDING_LIMIT } from '@bpm-web-app/utils';
import { useMemo, useEffect } from 'react';
import { MusicViewProps } from './music-view-props';
import { GhostComponent, NoResultsBlock, SecondaryPageTitle } from '../shared';
import { TrackListSupreme } from '../shared/track-list/supreme/track-list-supreme';
import { TrackListPresetSupreme } from '../shared/track-list/supreme/track-list-supreme-helpers';

export function TrendingMusicView(trendingMusicProps: MusicViewProps) {
    const { query, title, isLoading, setIsLoading } = trendingMusicProps;
    const { isDownload } = useHubSwitch();

    const { data: trendingData, isLoading: isLoadingTrendingData } = useTrending(isDownload ? 'download' : 'stream', {
        period: DEFAULT_PERIOD,
        limit: DEFAULT_BROWSE_TRENDING_LIMIT,
        category: query?.category as string || undefined,
        library: query?.library,
        genre: query?.genre as string || undefined,
    });

    const trending = useMemo(
        () => (trendingData?.data || []) as DownloadAlbum[] | MediaWithAlbum[],
        [trendingData?.data]
    );

    useEffect(() => {
        if (setIsLoading) {
            setIsLoading(isLoadingTrendingData);
        }
    }, [isLoadingTrendingData, setIsLoading]);

    const isLoadingAnything = useMemo(() => {
        return isLoading || isLoadingTrendingData;
    }, [isLoading, isLoadingTrendingData]);

    if (isLoadingAnything) {
        return (<GhostComponent type="trending" title={title} />);
    }

    return (
        <div className="spacing--section-bottom">
            <SecondaryPageTitle title={title as string} />
            <div className="spacing--top" />
            {trending.length > 0
                ? (
                    <div className="spacing__window--horizontal">
                        <TrackListSupreme
                            preset={isDownload ? TrackListPresetSupreme.DownloadTrending : TrackListPresetSupreme.StreamTrending}
                            list={trending}
                            isSortable={false}
                            trendingStatusToShow="trending_status_weekly"
                        />
                    </div>
                )
                : <NoResultsBlock hasMargin>{`No Trending ${title} Available`}</NoResultsBlock>}
        </div>

    );
}
